onDomLoad(function ($dom) {
  $dom.find('[data-behaviour="export-configuration-form"]').each(function () {
    const useLandscapeHeaderCheckbox = this.querySelector(
      '#export_configuration_use_landscape_header'
    )
    const useLandscapeFooterCheckbox = this.querySelector(
      '#export_configuration_use_landscape_footer'
    )
    const landscapeHeaderWrapper = this.querySelector(
      '#landscape_header_wrapper'
    )
    const landscapeFooterWrapper = this.querySelector(
      '#landscape_footer_wrapper'
    )

    function updateVisibility(checkbox, wrapper) {
      if (checkbox.checked) {
        wrapper.style.display = 'block'
      } else {
        wrapper.style.display = 'none'
      }
    }

    updateVisibility(useLandscapeHeaderCheckbox, landscapeHeaderWrapper)
    useLandscapeHeaderCheckbox.addEventListener('change', () =>
      updateVisibility(useLandscapeHeaderCheckbox, landscapeHeaderWrapper)
    )
    updateVisibility(useLandscapeFooterCheckbox, landscapeFooterWrapper)
    useLandscapeFooterCheckbox.addEventListener('change', () =>
      updateVisibility(useLandscapeFooterCheckbox, landscapeFooterWrapper)
    )
  })
})
